import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";

interface ShowProps extends ComponentProps<any> {
  condition: boolean;
}

const Show: FC<ShowProps> = ({ condition, children }) => {
  if (condition) return <>{children}</>;
  return null;
};

export default React.memo(Show);
